import constants from "../constants.js";

const CountryPnrFinishingRemarksGdsRemarksSeatRemarks = {
  displayName: "Seat Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.SeatRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks = {
  displayName: "Ancillary Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.AncillaryRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions = {
  displayName: "Finishing Remarks Exclusions",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks = {
  displayName: "Finishing Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.FinishingRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksName = {
  displayName: "Name",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksItem = {
  displayName: "Item",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks.$GdsRemarksItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CountryPnrFinishingRemarksGdsRemarksName,
    CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks,
    CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions,
    CountryPnrFinishingRemarksGdsRemarksSeatRemarks,
    CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks
  ],
  endpoint: "Settings",
  removeParamId: "GdsRemarksItem",
  canDelete: true,
};

const GdsSettings = {
  displayName: "Settings",
  dataAt: "Gds.$GdsItem.Settings",
  displayAs: constants.DISPLAY_AS.KEY_VALUE_PAIRS,
  keyOptions: "GDSSettingsOptions",
};

const UnusedTicketSettings = {
  displayName: "Enabled Unused Ticket Providers",
  dataAt: "EnabledUnusedTicketProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "UnusedTicketProviderTypes",
};

const DateFormatLongSettings = {
  displayName: "Date Format Long",
  dataAt: "DateTimeSettings.DateFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MMM Do YYYY."
}

const DateFormatMediumSettings = {
  displayName: "Date Format Medium",
  dataAt: "DateTimeSettings.DateFormatMedium",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MMM DD, YYYY."
}

const DateFormatShortSettings = {
  displayName: "Date Format Short",
  dataAt: "DateTimeSettings.DateFormatShort",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: MM/DD/YYYY."
}

const DatetimeFormatLongSettings = {
  displayName: "Datetime Format",
  dataAt: "DateTimeSettings.DateTimeFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: ddd, MMM D YYYY [at] h:mm a."
}

const TimeFormatLongSettings = {
  displayName: "Time Format Long",
  dataAt: "DateTimeSettings.TimeFormatLong",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  label: "Default format: h:mm a."
}

const ItineraryValidatorSettings = {
  displayName: "Enabled Itinerary Validators",
  dataAt: "EnabledItineraryValidators",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "ItineraryValidatorTypes",
};

const BookingThreshold = {
  displayName: "Booking Threshold (In Minutes)",
  dataAt:
    "BookingThresholdInMinutes",
  displayAs: constants.DISPLAY_AS.RANGE,
  min: 0,
  max: 36000,
  step: 15,
  defaultValue: 0,
  units: "minutes",
};

const GdsEnabled = {
  displayName: "Enabled",
  dataAt: "Gds.$GdsItem.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GdsName = {
  displayName: "Name",
  dataAt: "Gds.$GdsItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GdsPassiveFlightSegmentRemarkTemplate = {
  displayName: "Item",
  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    {
      displayName: "Type",
      dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Type",
      displayAs: constants.DISPLAY_AS.SELECT,
      optionsAt: "RemarkType",
    },
    {
      displayName: "Template",
      dataAt:
        "Gds.$GdsItem.PassiveFlightSegmentRemarks.$RemarkTemplate.Template",
      displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    },
  ],
  endpoint: "Settings",
  removeParamId: "RemarkTemplate",
  canDelete: true,
};

const GdsPassiveFlightSegmentRemarks = {
  displayName: "Passive Flight Segment Remarks",
  dataAt: "Gds.$GdsItem.PassiveFlightSegmentRemarks",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdsPassiveFlightSegmentRemarkTemplate,
  gridCols: [
    { name: "Type", key: "Type" },
    { name: "Template", key: "Template" },
  ],
};

const GuestTravellersTitlesEnabled = {
  displayName: "Enabled",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Enabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GuestTravellersTitlesValid = {
  displayName: "Valid",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Valid",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GuestTravellersTitlesIsDeleted = {
  displayName: "Deleted",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.IsDeleted",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const GuestTravellersTitlesDisplayOrder = {
  displayName: "Display Order",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.DisplayOrder",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const GuestTravellersTitlesName = {
  displayName: "Name",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true,
};

const GuestTravellersTitlesCode = {
  displayName: "Code",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const VehicleDefaultsImageUrl = {
  displayName: "Image Url",
  dataAt: "VehicleDefaults.$vehicleDefaultItem.ImageUrl",
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: "CarSupplier",
  uploadType: "image",
};

const VehicleDefaultsTypeCode = {
  displayName: "Type Code",
  dataAt: "VehicleDefaults.$vehicleDefaultItem.TypeCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const VehicleDefaultsCategoryCode = {
  displayName: "Category Code",
  dataAt: "VehicleDefaults.$vehicleDefaultItem.CategoryCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const VehicleDefaultsName = {
  displayName: "Name",
  dataAt: "VehicleDefaults.$vehicleDefaultItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const TermsAndConditionsSectionType = {
  displayName: "Section Type",
  dataAt: "TermsAndConditions.$termsItem.SectionType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "SectionType",
};

const TermsAndConditionsText = {
  displayName: "Text",
  dataAt: "TermsAndConditions.$termsItem.Text",
  displayAs: constants.DISPLAY_AS.TEXT_AREA,
};

const TermsAndConditionsSegmentTypes = {
  displayName: "Segment Types",
  dataAt: "TermsAndConditions.$termsItem.SegmentTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "SegmentTypes",
};

const TermsAndConditionsCountries = {
  displayName: "Countries",
  dataAt: "TermsAndConditions.$termsItem.Countries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const FlightFareDataFareClassType = {
  displayName: "Type",
  dataAt: "FlightFareData.$flFareDataItem.Type",
  displayAs: constants.DISPLAY_AS.FARE_CLASS_TYPE_SELECT,
  required: true,
};

const FlightFareDataMixedTypeRestriction = {
  displayName: "Mixed Type Restriction",
  dataAt: "FlightFareData.$flFareDataItem.MixedTypeRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  required: true,
};

const FlightFareDataRefundableRestriction = {
  displayName: "Refundable Restriction",
  dataAt: "FlightFareData.$flFareDataItem.RefundableRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  booleanRestrictionFilter: "refundableRestrictionDisplay",
  required: true,
};

const FlightFareDataRefundPenaltyRestriction = {
  displayName: "Refund Penalty Restriction",
  dataAt: "FlightFareData.$flFareDataItem.RefundPenaltyRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  required: true,
};

const FlightFareDataChangeableRestriction = {
  displayName: "Changeable Restriction",
  dataAt: "FlightFareData.$flFareDataItem.ChangeableRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  booleanRestrictionFilter: "changeableRestrictionDisplay",
  required: true,
};

const FlightFareDataBasicRestriction = {
  displayName: "Basic Restriction",
  dataAt: "FlightFareData.$flFareDataItem.BasicRestriction",
  displayAs: constants.DISPLAY_AS.BOOLEAN_RESTRICTION_SELECT,
  required: true,
};

const FlightFareDataName = {
  displayName: "Name",
  dataAt: "FlightFareData.$flFareDataItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ErrorMessagesValue = {
  displayName: "Value",
  dataAt: "ErrorMessages.$ErMesItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ErrorMessagesKey = {
  displayName: "Key",
  dataAt: "ErrorMessages.$ErMesItem.Key",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const ErrorMessagesUseRegularExpressions = {
  displayName: "Use Regular Expressions",
  dataAt: "ErrorMessages.$ErMesItem.UseRegularExpressions",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightFareBucketClassesFareClasses = {
  displayName: "Fare Classes",
  dataAt:
    "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.FareClasses",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const FlightFareBucketClassesSort = {
  displayName: "Sort",
  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Sort",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const FlightFareBucketClassesName = {
  displayName: "Name",
  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const SalesAgentsIsEnabled = {
  displayName: "Is Enabled",
  dataAt: "SalesAgents.$salSalesAgentsItem.IsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const SalesAgentsName = {
  displayName: "Name",
  dataAt: "SalesAgents.$salSalesAgentsItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const SalesAgentsCode = {
  displayName: "Code",
  dataAt: "SalesAgents.$salSalesAgentsItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PerDiemDefaultRatesEffectiveDate = {
  displayName: "Effective Date",
  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.EffectiveDate",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PerDiemDefaultRatesCountry = {
  displayName: "Country",
  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.Country",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PerDiemDefaultRatesAmount = {
  displayName: "Amount",
  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem.Amount",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PerDiemMappingsValue = {
  displayName: "Value",
  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.Value",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const PerDiemMappingsAlternateValues = {
  displayName: "Alternate Values",
  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.AlternateValues",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const PerDiemMappingsType = {
  displayName: "Type",
  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem.Type",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "PerDiemMappingsTypes",
  defaultValue: "City",
};

const HotelRateCategoriesName = {
  displayName: "Rate Category Name",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelRateCategoriesKeywords = {
  displayName: "Keywords",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.Keywords",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelRateCategoriesContractCodes = {
  displayName: "Contract Codes",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.ContractCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelRateCategoriesSabreSourceType = {
  displayName: "Sabre Source Type",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.SabreSourceType",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelRateCategoriesFilterDisplayName = {
  displayName: "Filter Display Name",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.FilterDisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelRateCategoriesLogoUrl = {
  displayName: "Upload Rate Logo",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.LogoUrl",
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'RateCategory',
  uploadType: 'svg'
};

const HotelRateCategoriesDisplayOnTop = {
  displayName: "Display On Top",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.DisplayOnTop",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelRateCategoriesIsAggregator = {
  displayName: "Show this as an aggregator",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem.IsAggregator",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelAmenityFiltersDisplayName = {
  displayName: "Display Name",
  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.DisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelAmenityFiltersMostPopular = {
  displayName: "Show in Most Popular Category",
  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.MostPopular",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const HotelAmenityFiltersAmenities = {
  displayName: "Amenities",
  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem.Amenities",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const RailCharacterMappingsSpecialCharacter = {
  displayName: "Special Character",
  dataAt:
    "RailCharacterMappings.$rcmRailCharacterMappingsItem.SpecialCharacter",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const RailCharacterMappingsSystemCharacter = {
  displayName: "System Character",
  dataAt: "RailCharacterMappings.$rcmRailCharacterMappingsItem.SystemCharacter",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CountryPnrFinishingRemarksGdsRemarksGrid = {
  displayName: "Gds Remarks",
  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.GdsRemarks",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CountryPnrFinishingRemarksGdsRemarksItem,
  gridCols: [{ name: "Name", key: "Name" }],
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks = {
  displayName: "Expired Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions = {
  displayName: "Expired Remarks Exclusions",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks =
  {
    displayName: "Declined Remarks NonRefundable Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions =
  {
    displayName: "Declined Remarks NonRefundable Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarksNonRefundable.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks = {
  displayName: "Declined Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions =
  {
    displayName: "Declined Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.DeclinedRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks = {
  displayName: "Approval Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions =
  {
    displayName: "Approval Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ApprovalRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks = {
  displayName: "Cancel Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.CancelRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions = {
  displayName: "Cancel Remarks Exclusions",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.CancelRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks = {
  displayName: "Modify Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ModifyRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions = {
  displayName: "Modify Remarks Exclusions",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ModifyRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks = {
  displayName: "User Hold Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.UserHoldRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions =
  {
    displayName: "User Hold Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.UserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks =
  {
    displayName: "Expired User Hold Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions =
  {
    displayName: "Expired User Hold Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ExpiredUserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

//
const CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksRemarks =
  {
    displayName: "Confirmed User Hold Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksExclusions =
  {
    displayName: "Confirmed User Hold Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.ConfirmedUserHoldRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksFinishBookingRemarksRemarks =
  {
    displayName: "Finish Booking Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.FinishBookingRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksAdditionalPnrRemarksFinisherBookingRemarksExclusions =
  {
    displayName: "Finish Booking Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.AdditionalPnrRemarks.FinishBookingRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };
//

const CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks =
  {
    displayName: "Guest Traveller Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions =
  {
    displayName: "Guest Traveller Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks =
  {
    displayName: "Pre Trip Approval Remarks Remarks",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions =
  {
    displayName: "Pre Trip Approval Remarks Exclusions",
    dataAt:
      "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
    displayAs: constants.DISPLAY_AS.TAG_INPUT,
  };

const CountryPnrFinishingRemarksHostCommands = {
  displayName: "Host Commands",
  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.HostCommands",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksHostCommandsInfo = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  html: "<ol start='0'>" + 
  "<li>Debtor</li>" +
  "<li>ItineraryPassenger</li>" +
  "<li>object CurrentUser</li>" +
  "<li>CreditCardDetails</li>" +
  "<li>string PassengerCreditCardShortYear</li>" +
  "<li>List&ltAirTicket&gt</li>" +
  "<li>List&ltRailTicket&gt</li>" +
  "</ol>"
};

const CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks = {
  displayName: "Standard Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.StandardRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarksInfo = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  html: "<ol start='0'>" + 
  "<li>Itinerary</li>" +
  "<li>ItineraryPassenger</li>" +
  "<li>List&ltItineraryPassengerHotel&gt</li>" +
  "<li>List&ltItineraryPassengerFlight&gt</li>" +
  "<li>List&ltItineraryPassengerCar&gt</li>" +
  "<li>Debtor</li>" +
  "<li>string Role</li>" +
  "<li>object GuestTraveller</li>" +
  "<li>ItineraryPassengerApprover</li>" +
  "<li>List&ltItineraryPassengerRail&gt</li>" +
  "<li>{ TimePolicyCode, TimePolicyTitle, IsInTimePolicy, LeadTimeForInPolicyBooking }</li>" +
  "<li>List&ltItineraryPassengerGroundTrans&gt</li>" +
  "<li>DateTime.Now</li>" +
  "<li>List&ltAirTicket&gt</li>" +
  "<li>List&ltRailTicket&gt</li>" +
  "<li>List&ltVirtualPayments&gt</li>" +
  "<li>List&ltVirtualPaymentCanceled&gt</li>" +
  "<li>{ LoggedInUserEmail, LoggedInUserName, LoggedInEmployeeCode, LoggedInEmployeeNumber, LoggedInEmployeeDepartment, LoggedInEmployeeCostCenter, LoggedInUserRole }</li>" +
  "</ol>"
};

const CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks = {
  displayName: "Exclusion Remarks",
  dataAt:
    "CountryPnrFinishingRemarks.$CntPnrFinRemItem.PnrFinishingRemarks.ExclusionRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryPnrFinishingRemarksCountryCode = {
  displayName: "Country Code",
  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem.CountryCode",
  displayAs: constants.DISPLAY_AS.COUNTRY_SELECT,
  selectType: "single",
};

const CreditCardMappingsCardProvider = {
  displayName: "Card Provider",
  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem.CardProvider",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CreditCardMappingsCardTypes = {
  displayName: "Card Types",
  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem.CardTypes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const GdssettingsItem = {
  displayName: "Gds Item",
  dataAt: "Gds.$GdsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GdsName, GdsEnabled,{
    displayAs: constants.DISPLAY_AS.SUB_HEADING,
    html: "<a href=\"https://trvlcorp.sharepoint.com/:x:/r/sites/ctmna-Technology/Shared%20Documents/Lightning/LightningConfig_GdsKeywords.xlsx?d=w67300e626de94f7b8e6bb5f3366ffa29&csf=1&web=1&e=ttOATy\" target=\"_blank\">Sharepoint - GDS Keyword Dictionary</a>"
  }, GdsSettings, GdsPassiveFlightSegmentRemarks],
  endpoint: "Settings",
  removeParamId: "GdsItem",
  canDelete: true,
};

const GuestTravellersTitlesGroup = {
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: "",
  children: [
    GuestTravellersTitlesCode,
    GuestTravellersTitlesName,
    GuestTravellersTitlesDisplayOrder,
    GuestTravellersTitlesIsDeleted,
    GuestTravellersTitlesValid,
    GuestTravellersTitlesEnabled,
  ],
};

const VehicleDefaultsItem = {
  displayName: "Item",
  dataAt: "VehicleDefaults.$vehicleDefaultItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    VehicleDefaultsName,
    VehicleDefaultsCategoryCode,
    VehicleDefaultsTypeCode,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label:
        "Type Code: Single Alpha character for Sabre.Car TypeCode and full VehicleType name for Ground Transport",
    },
    VehicleDefaultsImageUrl,
  ],
  endpoint: "Settings",
  removeParamId: "vehicleDefaultItem",
  canDelete: true,
};

const VehicleEmissionCarCategoryCodes = {
  displayName: "Car Category Codes",
  dataAt: "VehicleEmissions.$vehicleEmissionItem.CarCategoryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const VehicleEmissionFuelCodes = {
  displayName: "Fuel Codes",
  dataAt: "VehicleEmissions.$vehicleEmissionItem.FuelCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const VehicleEmissionValue = {
  displayName: "Kilograms of Carbon Dioxide Per Kilometer (Kg CO2 per Km)",
  dataAt: "VehicleEmissions.$vehicleEmissionItem.EmissionValuePerKm",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const VehicleEmissionsItem = {
  displayName: "Item",
  dataAt: "VehicleEmissions.$vehicleEmissionItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    VehicleEmissionCarCategoryCodes,
    VehicleEmissionFuelCodes,
    VehicleEmissionValue,
  ],
  endpoint: "Settings",
  removeParamId: "vehicleEmissionItem",
  canDelete: true,
};

const TermsAndConditionsSettingsItem = {
  displayName: "Item",
  dataAt: "TermsAndConditions.$termsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    TermsAndConditionsSectionType,
    TermsAndConditionsCountries,
    TermsAndConditionsSegmentTypes,
    TermsAndConditionsText,
  ],
  endpoint: "Settings",
  removeParamId: "termsItem",
  canDelete: true,
};

const FlightFareDataItem = {
  displayName: "Item",
  dataAt: "FlightFareData.$flFareDataItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlightFareDataName,
    FlightFareDataFareClassType,
    FlightFareDataMixedTypeRestriction,
    FlightFareDataRefundableRestriction,
    FlightFareDataRefundPenaltyRestriction,
    FlightFareDataChangeableRestriction,
    FlightFareDataBasicRestriction,
  ],
  endpoint: "Settings",
  removeParamId: "flFareDataItem",
  canDelete: true,
};

const ErrorMessagesItem = {
  displayName: "Item",
  dataAt: "ErrorMessages.$ErMesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    ErrorMessagesKey,
    ErrorMessagesValue,
    ErrorMessagesUseRegularExpressions,
  ],
  endpoint: "Settings",
  removeParamId: "ErMesItem",
  canDelete: true,
};

const FlightFareBucketClassesItem = {
  displayName: "Item",
  dataAt: "FlightFareBucketClasses.$ffbcFlightFareBucketClassesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlightFareBucketClassesName,
    FlightFareBucketClassesSort,
    FlightFareBucketClassesFareClasses,
  ],
  endpoint: "Settings",
  removeParamId: "ffbcFlightFareBucketClassesItem",
  canDelete: true,
};

const SalesAgentsItem = {
  displayName: "Item",
  dataAt: "SalesAgents.$salSalesAgentsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [SalesAgentsIsEnabled, SalesAgentsName, SalesAgentsCode],
  endpoint: "Settings",
  removeParamId: "salSalesAgentsItem",
  canDelete: true,
};

const PerDiemDefaultRatesItem = {
  displayName: "Item",
  dataAt: "PerDiemDefaultRates.$pdPerDiemDefaultRatesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    PerDiemDefaultRatesEffectiveDate,
    PerDiemDefaultRatesCountry,
    PerDiemDefaultRatesAmount,
  ],
  endpoint: "Settings",
  removeParamId: "pdPerDiemDefaultRatesItem",
  canDelete: true,
};

const PerDiemMappingsItem = {
  displayName: "Item",
  dataAt: "PerDiemMappings.$pdPerDiemMappingsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    PerDiemMappingsValue,
    PerDiemMappingsAlternateValues,
    PerDiemMappingsType,
  ],
  endpoint: "Settings",
  removeParamId: "pdPerDiemMappingsItem",
  canDelete: true,
};

const HotelRateCategoriesItem = {
  displayName: "Item",
  dataAt: "HotelRateCategories.$hrcHotelRateCategoriesItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    HotelRateCategoriesName, 
    HotelRateCategoriesKeywords, 
    HotelRateCategoriesContractCodes, 
    HotelRateCategoriesSabreSourceType, 
    HotelRateCategoriesFilterDisplayName, 
    HotelRateCategoriesDisplayOnTop, 
    HotelRateCategoriesIsAggregator, 
    HotelRateCategoriesLogoUrl
  ],
  endpoint: "Settings",
  removeParamId: "hrcHotelRateCategoriesItem",
  canDelete: true,
};

const HotelAmenityFiltersItem = {
  displayName: "Item",
  dataAt: "HotelAmenityFilters.$hafHotelAmenityFiltersItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [HotelAmenityFiltersDisplayName, HotelAmenityFiltersMostPopular, HotelAmenityFiltersAmenities],
  endpoint: "Settings",
  removeParamId: "hafHotelAmenityFiltersItem",
  canDelete: true,
};

const RailCharacterMappingsItem = {
  displayName: "Item",
  dataAt: "RailCharacterMappings.$rcmRailCharacterMappingsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    RailCharacterMappingsSpecialCharacter,
    RailCharacterMappingsSystemCharacter,
  ],
  endpoint: "Settings",
  removeParamId: "rcmRailCharacterMappingsItem",
  canDelete: true,
};

const CountryPnrFinishingRemarksGridItem = {
  displayName: "Country PNR Finishing Remark",
  dataAt: "CountryPnrFinishingRemarks.$CntPnrFinRemItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CountryPnrFinishingRemarksCountryCode,
    CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks,
    CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks,
    CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarksInfo,
    CountryPnrFinishingRemarksHostCommands,
    CountryPnrFinishingRemarksHostCommandsInfo,
    CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions,
    CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks,
    CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions,
    CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksConfirmedUserHoldRemarksExclusions,
    CountryPnrFinishingRemarksAdditionalPnrRemarksFinishBookingRemarksRemarks,
    CountryPnrFinishingRemarksAdditionalPnrRemarksFinisherBookingRemarksExclusions,
    CountryPnrFinishingRemarksGdsRemarksGrid,
  ],
  endpoint: "Settings",
  routeParamId: "",
  removeParamId: "CntPnrFinRemItem",
  canDelete: true,
};

const CreditCardMappingsItem = {
  displayName: "Item",
  dataAt: "CreditCardMappings.$ccCreditCardMappingsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    CreditCardMappingsCardProvider,
    CreditCardMappingsCardTypes
  ],
  endpoint: "Settings",
  removeParamId: "ccCreditCardMappingsItem",
  canDelete: true,
};

const Gdssettings = {
  displayName: "Gds",
  dataAt: "Gds",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GdssettingsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Enabled", key: "Enabled" },
  ],
};

const PnrFinishingRemarksPanelStandardRemarks = {
  displayName: "Standard Remarks",
  dataAt: "PnrFinishingRemarks.StandardRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const PnrFinishingRemarksPanelPreTripApprovalRemarks = {
  displayName: "Pre Trip Approval Remarks",
  dataAt: "PnrFinishingRemarks.PreTripApprovalRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const PnrFinishingRemarksPanelPreTripApprovalExclusions = {
  displayName: "Pre Trip Approval Exclusions",
  dataAt: "PnrFinishingRemarks.PreTripApprovalRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const PnrFinishingRemarksPanelGuestTravellerRemarks = {
  displayName: "Guest Traveller Remarks",
  dataAt: "PnrFinishingRemarks.GuestTravellerRemarks.Remarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const PnrFinishingRemarksPanelGuestTravellerExclusions = {
  displayName: "Guest Traveller Exclusion Remarks",
  dataAt: "PnrFinishingRemarks.GuestTravellerRemarks.Exclusions",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const GuestTravellersTitlesGridItem = {
  displayName: "Guest Travellers Title",
  dataAt: "GuestTravellersTitles.$gusTravTitleItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [GuestTravellersTitlesGroup],
  endpoint: "Settings",
  removeParamId: "gusTravTitleItem",
  canDelete: true,
};

const AdditionalPnrRemarksExpiredRemarks = {
  displayName: "Expired Remarks",
  dataAt: "AdditionalPnrRemarks.ExpiredRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksDeclinedRemarksNonRefundable = {
  displayName: "Declined Remarks Non-refundable",
  dataAt: "AdditionalPnrRemarks.DeclinedRemarksNonRefundable",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksDeclinedRemarks = {
  displayName: "Declined Remarks",
  dataAt: "AdditionalPnrRemarks.DeclinedRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksApprovalRemarks = {
  displayName: "Approval Remarks",
  dataAt: "AdditionalPnrRemarks.ApprovalRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksCancelRemarks = {
  displayName: "Cancel Remarks",
  dataAt: "AdditionalPnrRemarks.CancelRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksModifyRemarks = {
  displayName: "Modify Remarks",
  dataAt: "AdditionalPnrRemarks.ModifyRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksUserHoldRemarks = {
  displayName: "User Hold Remarks",
  dataAt: "AdditionalPnrRemarks.UserHoldRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksExpiredUserHoldRemarks = {
  displayName: "Expired User Hold Remarks",
  dataAt: "AdditionalPnrRemarks.ExpiredUserHoldRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksConfirmedUserHoldRemarks = {
  displayName: "Confirmed User Hold Remarks",
  dataAt: "AdditionalPnrRemarks.ConfirmedUserHoldRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const AdditionalPnrRemarksFinishBookingRemarks = {
  displayName: "Finish Booking Remarks",
  dataAt: "AdditionalPnrRemarks.FinishBookingRemarks",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const VehicleDefaultsGrid = {
  displayName: "Vehicle Defaults",
  dataAt: "VehicleDefaults",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: VehicleDefaultsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Category Code", key: "CategoryCode" },
    { name: "Type Code", key: "TypeCode" },
  ],
};

const VehicleEmissionsGrid = {
  displayName: "Vehicle Emissions",
  dataAt: "VehicleEmissions",
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: VehicleEmissionsItem,
  gridCols: [
    { name: "Car Codes", key: "CarCategoryCodes" },
    { name: "Fuel Codes", key: "FuelCodes" },
    { name: "Kg CO2 per Km", key: "EmissionValuePerKm" },
  ],
};

const TermsAndConditionsGrid = {
  displayName: "Terms and Condition",
  dataAt: "TermsAndConditions",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: TermsAndConditionsSettingsItem,
  gridCols: [
    { name: "SectionType", key: "SectionType" },
    { name: "Countries", key: "Countries" },
    { name: "SegmentTypes", key: "SegmentTypes" },
  ],
};

const FlightFareDataGrid = {
  displayName: "Flight Fare Data",
  dataAt: "FlightFareData",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightFareDataItem,
  gridCols: [{ name: "Name", key: "Name" }],
};

const DefaultFareRules = {
  displayName: "Default Fare Rules",
  dataAt: "DefaultFareRules",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const HotelPreferredTagsSourceType = {
  displayName: "CTM Preferred Tier Labels",
  dataAt: "HotelPreferredTagsSourceType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "SettingsHotelPreferredTagsSourceType",
};

const HotelTagsToIgnoreFromDatabase = {
  displayName: "Tags to Ignore",
  dataAt: "HotelTagsToIgnoreFromDatabase",
  displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
  endpoint: "Hotels/GetAllTags",
  searchAllNo: true,
  isMultiSelect: true,
  showOnlySelectedField: true,
};

const HotelDepositRequiredAndPrepayKeywords = {
  displayName: "Hotel Deposit/Prepay keywords",
  dataAt: "HotelDepositRequiredAndPrepayKeywords",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelNonRefundableKeywords = {
  displayName: "Hotel Non-Refundable keywords",
  dataAt: "HotelNonRefundableKeywords",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const HotelOtherExcludedKeywords = {
  displayName: "Hotel Other Excluded Keywords",
  dataAt: "HotelOtherExcludedKeywords",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ExcludedHotelChains = {
  displayName: "Excluded Chains",
  dataAt: "ExcludedHotelChains",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ExcludedHotels = {
  displayName: "Excluded Hotels",
  dataAt: "ExcludedHotels",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const RateKeywordsIdRequired = {
  displayName: "Rate Keywords that show ID Required Message",
  dataAt: "RateKeywordsIdRequired",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const ErrorMessagesGrid = {
  displayName: "Error Messages",
  dataAt: "ErrorMessages",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: ErrorMessagesItem,
  gridCols: [{ name: "Key", key: "Key" }],
};

const MinimumHotelRating = {
  displayName: "Minimum Hotel Rating",
  dataAt: "MinimumHotelRating",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: 0,
  max: 4,
};

const SettingsRadiusDistance = {
  displayName: "Hotel Radius Distance",
  dataAt: "RadiusDistance",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
  min: 0,
  max: 9999999999,
};

const LimitCountries = {
  displayName: "Limit Countries",
  dataAt: "LimitCountries",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const FlightFareBucketClassesGrid = {
  displayName: "Flight Fare Bucket Data",
  dataAt: "FlightFareBucketClasses",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: FlightFareBucketClassesItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Classes", key: "FareClasses" },
    { name: "Sort", key: "Sort" },
  ],
};

const FlightFareClasses = {
  displayName: "Flight Fare Classes",
  dataAt: "FlightFareClasses",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const SalesAgentRemark = {
  displayName: "Remarks",
  dataAt: "SalesAgentRemark",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const SalesAgentsGrid = {
  tabName: "Sales-Agents",
  displayName: "Sales Agents",
  dataAt: "SalesAgents",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: SalesAgentsItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Code", key: "Code" },
  ],
};

const PerDiemDefaultRatesGrid = {
  tabName: "per-diem-default-rates",
  displayName: "Per Diem Default Rates",
  dataAt: "PerDiemDefaultRates",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PerDiemDefaultRatesItem,
  gridCols: [
    { name: "Effective Date", key: "EffectiveDate" },
    { name: "Country", key: "Country" },
    { name: "Amount", key: "Amount" },
  ],
};

const PerDiemMappingsGrid = {
  tabName: "per-diem-mappings",
  displayName: "Per Diem Mappings",
  dataAt: "PerDiemMappings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: PerDiemMappingsItem,
  gridCols: [
    { name: "Value", key: "Value" },
    { name: "Alternate Values", key: "AlternateValues" },
    { name: "Type", key: "Type" },
  ],
};

const HotelRateCategoriesGrid = {
  tabName: "Hotel-Rate-Categories",
  displayName: "Hotel Rate Categories",
  dataAt: "HotelRateCategories",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelRateCategoriesItem,
  gridCols: [
    { name: "Rate Category Name", key: "Name" },
    { name: "Keywords", key: "Keywords" },
    { name: "Contract Codes", key: "ContractCodes" },
    { name: "Source Type", key: "SabreSourceType" },
    { name: "Icon", key: "LogoUrl" },
    { name: "Display On Top", key: "DisplayOnTop" },
    { name: "Aggregator", key: "IsAggregator" },
    { name: "Filter Display Name", key: "FilterDisplayName" }
  ],
  sortable: true,
   htmlInner: "<small>All rows are shown. <br/>Sort rows by dragging and dropping to desired order for shopping results.</small>"
};

const HotelAmenityFiltersGrid = {
  tabName: "hotel-amenity-filters",
  displayName: "Hotel Amenity Filters",
  dataAt: "HotelAmenityFilters",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: HotelAmenityFiltersItem,
  gridCols: [
    { name: "Display Name", key: "DisplayName" },
    { name: "Amenities", key: "Amenities" },
    { name: "Most Popular", key: "MostPopular" }
  ],
};

const RailCharacterMappingsGrid = {
  tabName: "character-mappings",
  displayName: "Character Mappings",
  dataAt: "RailCharacterMappings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: RailCharacterMappingsItem,
  gridCols: [
    { name: "Special Character", key: "SpecialCharacter" },
    { name: "System Character", key: "SystemCharacter" },
  ],
};

const Id = {
  displayName: "Identifier",
  dataAt: "Id",
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const CountryPnrFinishingRemarksGrid = {
  tabName: "Country-PNR-Remarks",
  displayName: "Country PNR Remarks",
  dataAt: "CountryPnrFinishingRemarks",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CountryPnrFinishingRemarksGridItem,
  gridCols: [{ name: "Country Code", key: "CountryCode" }],
};

const CreditCardMappingsGrid = {
  tabName: "credit-card-mappings",
  displayName: "Credit Card Mappings",
  dataAt: "CreditCardMappings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CreditCardMappingsItem,
  gridCols: [
    { name: "Card Provider", key: "CardProvider" },
    { name: "Card Types", key: "CardTypes" },
  ],
};

const SettingsGDSPanel = {
  dataAt: "",
  tabName: "GDS",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [Gdssettings],
};

const PnrFinishingRemarksPanel = {
  tabName: "PNR-Finishing-Remarks",
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: "PnrFinishingRemarks",
  children: [
    PnrFinishingRemarksPanelGuestTravellerExclusions,
    PnrFinishingRemarksPanelGuestTravellerRemarks,
    PnrFinishingRemarksPanelPreTripApprovalExclusions,
    PnrFinishingRemarksPanelPreTripApprovalRemarks,
    PnrFinishingRemarksPanelStandardRemarks,
  ],
};

const GuestTravellersTitlesPanel = {
  tabName: "Guest-Travellers-Titles",
  displayName: "Guest Travellers Titles",
  dataAt: "GuestTravellersTitles",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: GuestTravellersTitlesGridItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Code", key: "Code" },
    { name: "Display Order", key: "DisplayOrder" },
  ],
};

const ApprovalPanel = {
  tabName: "Approvals",
  displayName: "Approvals",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
    children: [
      {
        displayAs: constants.DISPLAY_AS.SUB_HEADING,
        html:
          "<h4>Agent Claimed Remark</h4><small>When remark text is populated User hold and approval expiry will not occur when defined remark exist in booking.</small>",
      },
      {
        displayName: "Agent Claimed Remark Type",
        dataAt: "ApprovalClaimedRemark.RemarkType",
        displayAs: constants.DISPLAY_AS.SELECT,
        optionsAt: "RemarkType",
      },
      {
        displayName: "Agent Claimed Remark Text",
        dataAt: "ApprovalClaimedRemark.RemarkText",
        displayAs: constants.DISPLAY_AS.TEXT_INPUT,
        html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
      },
      {
        displayName: "Agent Claimed Remark Code",
        dataAt: "ApprovalClaimedRemark.RemarkCode",
        displayAs: constants.DISPLAY_AS.TEXT_INPUT,
        label: "Optional value used when remark type is Alpha-Coded"
      }
    ],
}

const AdditionalPnrRemarksPanel = {
  tabName: "Additional-PNR-Remarks",
  displayAs: constants.DISPLAY_AS.GROUP,
  dataAt: "",
  children: [
    AdditionalPnrRemarksApprovalRemarks,
    AdditionalPnrRemarksDeclinedRemarks,
    AdditionalPnrRemarksDeclinedRemarksNonRefundable,
    AdditionalPnrRemarksExpiredRemarks,
    AdditionalPnrRemarksCancelRemarks,
    AdditionalPnrRemarksModifyRemarks,
    AdditionalPnrRemarksUserHoldRemarks,
    AdditionalPnrRemarksExpiredUserHoldRemarks,
    AdditionalPnrRemarksConfirmedUserHoldRemarks,
    AdditionalPnrRemarksFinishBookingRemarks,
  ],
};

const IsFlightSearchUniversalProductAttributesTabEnabled = {
  displayName: "Enable Flight Search Universal Product Attributes Tab",
  dataAt: "IsFlightSearchUniversalProductAttributesTabEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchUniversalProductAttributesTabLabel = {
  displayName: "Flight Search Universal Product Attributes Tab Label",
  dataAt: "FlightSearchUniversalProductAttributesTabLabel",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const IsFlightSearchUniversalProductAttributesShortcutEnabled = {
  displayName: "Enable Flight Search Universal Product Attributes Shortcut",
  dataAt: "IsFlightSearchUniversalProductAttributesShortcutEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchUniversalProductAttributesShortcutLabel = {
  displayName: "Flight Search Universal Product Attributes Shortcut Label",
  dataAt: "FlightSearchUniversalProductAttributesShortcutLabel",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};
const ConfigReportDownloader = {
  displayName: "Config Report Download",
  displayAs: constants.DISPLAY_AS.FILE_DOWNLOADER,
  fileNameSuffix: "DebtorConfigReport.xlsx",
  endPointController: "DebtorConfigReport",
};

const ConfigFileUploader = {
  displayName: 'Upload Bulk Changes',
  dataAt: 'MediumImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'ImportConfiguration',
  uploadType: 'xlsx',
  rawFileWithDate: true,
  isEnabledMethod: "vm.authService.getIsBulkChangeAdmin()"
};

const RegionalMobileContactDetailsFileUploader = {
  displayName: 'Upload Regional Mobile Contact Details',
  dataAt: 'MediumImageUrl',
  displayAs: constants.DISPLAY_AS.FILE_UPLOADER,
  fileContainer: 'RegionalMobileContactDetailsUpload',
  uploadType: 'xlsx',
  rawFileWithDate: true,
  isEnabledMethod: "vm.authService.getCanUploadRegionalMobileContactDetails()"
};

const EnableNewUiSystemSetting = {
  displayName: "Enable New UI",
  dataAt: "EnableNewUi",
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const TaxDisplayModeSystemSetting = {
  displayName: "Shopping Results - Rate Display Include Taxes",
  dataAt: "IncludeHotelTax",
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const SettingsMiscPanel = {
  tabName: "Settings-Misc",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    Id,
    FlightFareClasses,
    FlightFareBucketClassesGrid,
    LimitCountries,
    ItineraryValidatorSettings,
    BookingThreshold,
    ErrorMessagesGrid,
    DefaultFareRules,
    FlightFareDataGrid,
    TermsAndConditionsGrid,
    VehicleDefaultsGrid,
    VehicleEmissionsGrid,
    IsFlightSearchUniversalProductAttributesTabEnabled,
    FlightSearchUniversalProductAttributesTabLabel,
    IsFlightSearchUniversalProductAttributesShortcutEnabled,
    FlightSearchUniversalProductAttributesShortcutLabel,
    EnableNewUiSystemSetting,
  ],
};

const ConfigReportPanel = {
  tabName: "Debtor-Config-Report",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      label: "Configuration Report For all debtors in the system​​",
    },
    ConfigReportDownloader,
    ConfigFileUploader,
    RegionalMobileContactDetailsFileUploader,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html: "<h4><small>Sheets supported" +
      "<ul>" +
      "<li>Debtor<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b> used to identify debtor. Debtor Id must exist for the row to be processed</li>" +
      "</ul></li>" +
      "</ul></li>" +
      "<li>Company Reference<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b>, <b>Index</b> and <b>Code</b> used to identify Company Reference. Index and Code must exist for the row to be processed</li>" +
          "<li>Ignored Fields. Only used for reference purposes<ul>" +
          "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
        "</ul></li>" +
      "</ul></li>" +
      "</ul></li>" +
      "<li>Policy<ul>" +
      "<li>Fields handled<ul>" +
        "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify Policy. Policy Code must exist for the row to be processed</li>" +
        "<li>Ignored Fields. Only used for reference purposes<ul>" +
        "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
      "</ul></li>" +
    "</ul></li>" +
    "</ul></li>" +
      "<li>FlightPolicy<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" +
          "<li>Ignored Fields. Only used for reference purposes<ul>" +
          "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
        "</ul></li>" +
      "</ul></li>" +
      "</ul></li>" +
      "<li>FlightPolicyItems<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" +
          "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel, </br>" + 
              "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" +
          "</ul></li>" +
        "</ul></li>" +
      "</ul></li>" +
        "<li>HotelPolicy<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" +
          "<li>Ignored Fields. Only used for reference purposes<ul>" +
          "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
        "</ul></li>" +
      "</ul></li>" +
      "</ul></li>" +
      "<li>HotelPolicyItems<ul>" +
        "<li>Fields handled<ul>" +
          "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" +
          "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel, </br>" + 
              "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" +
          "</ul></li>" +
        "</ul></li>" +
        "</ul></li>" +
        "<li>CarPolicy<ul>" +
          "<li>Fields handled<ul>" +
            "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" +
            "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
          "</ul></li>" +
        "</ul></li>" +
        "</ul></li>" +
        "<li>CarPolicyItems<ul>" +
          "<li>Fields handled<ul>" +
            "<li><b>DebtorId</b>, <b>PolicyCode</b> and <b>PolicyIndex</b> are used to identify policy. Policy must exist for the row to be processed</li>" +
            "<li>Ignored Fields. Only used for reference purposes<ul>" +
              "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel,  </br>" +
              "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes</li>" +
            "</ul></li>" +
          "</ul></li>" +
          "</ul></li>" +
        "<li>RailPolicy<ul>" +
        "<li>Fields handled<ul>" +
            "<li><b>DebtorId</b> and <b>PolicyCode</b> used to identify policy. Policy Code must exist for the row to be processed</li>" +
            "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, PolicyTitle, PolicyCountries, PolicyLevel,  </br>" +
            "BreakPolicyEscalationApprovalLevel, PolicyEmployeCodes, PolicyAgencyReasonCodes, PolicyListings</li>" +
          "</ul></li>" +
        "</ul></li>" +
        "</ul></li>" +
        "<li>GdsSettings<ul>" +
        "<li>Fields handled<ul>" +
            "<li><b>DebtorId</b> and <b>GDSName</b> used to identify policy</li>" +
            "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled</li>" +
          "</ul></li>" +
        "</ul></li>" +
        "</ul></li>" +
        "<li>GdsSettingsKeywords<ul>" +
        "<li>Row replacement note items are read in a group by Debtor and GdsSettings. Rows in upload will replace current GdsSettingsKeywords in GdsSetting</li>" +
        "<li>Fields handled<ul>" +
            "<li><b>DebtorId</b> and <b>GDSName</b> used to identify policy</li>" +
            "<li>Ignored Fields. Only used for reference purposes<ul>" +
            "<li>DebtorName, DebtorTitle, DebtorIsDeleted, DebtorIsDisabled, GDSEnabled</li>" +
          "</ul></li>" +
        "</ul></li>" +
        "</ul></li>" +
      "</ul></small></h4>",
    },
  ],
};

const SalesAgentsPanel = {
  tabName: "Sales-Agents",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [SalesAgentRemark, SalesAgentsGrid],
};

const HotelPanel = {
  tabName: "Hotel",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    SettingsRadiusDistance,
    MinimumHotelRating,
    TaxDisplayModeSystemSetting,
    HotelPreferredTagsSourceType,
    HotelTagsToIgnoreFromDatabase,
    HotelDepositRequiredAndPrepayKeywords,
    HotelNonRefundableKeywords,
    HotelOtherExcludedKeywords,
    ExcludedHotelChains,
    ExcludedHotels,
    RateKeywordsIdRequired,
    HotelRateCategoriesGrid,
    HotelAmenityFiltersGrid
  ],
};

const RailPanel = {
  tabName: "Rail",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [RailCharacterMappingsGrid,
    {
      displayAs: constants.DISPLAY_AS.SUB_HEADING,
      html:
        "<h4>Rail Ticketing Configuration</h4><br/><small>When remark text is populated system will pause ticketing until remark exist in the Sabre booking.<br/>If no remark is set then system will ticket rail reservation immediately.</small>",
    },
    {
    displayName: "Rail Ticketing Remark Type",
    dataAt: "RailTicketingRemark.RemarkType",
    displayAs: constants.DISPLAY_AS.SELECT,
    optionsAt: "RemarkType",
  },
  {
    displayName: "Rail Ticketing Remark Text",
    dataAt: "RailTicketingRemark.RemarkText",
    displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    html: "<small><i>Leave blank to not pause ticketing.</i> Remark Text can be a regular expression</small>"
  },
  {
    displayName: "Rail Ticketing Remark Code",
    dataAt: "RailTicketingRemark.RemarkCode",
    displayAs: constants.DISPLAY_AS.TEXT_INPUT,
    label: "Optional value used when remark type is Alpha-Coded"
  }],
};

const PerDiemPanel = {
  tabName: "Per-Diem",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [PerDiemDefaultRatesGrid, PerDiemMappingsGrid],
};

const UnusedTicketPanel = {
  tabName: "Unused-Tickets",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [UnusedTicketSettings],
};

const DatetimeFormatPanel = {
  tabName: "Datetime-Format",
  dataAt:"",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ DateFormatLongSettings, DateFormatMediumSettings, DateFormatShortSettings, DatetimeFormatLongSettings, TimeFormatLongSettings ],
};

const CreditCardMappingsPanel = {
  tabName: "Credit-Card-Mappings",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CreditCardMappingsGrid],
};

//Named List
const NamedListName = {
  displayName: "List Name",
  dataAt: "NamedLists.$iinamedListItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const NamedListValues = {
  displayName: "List Values",
  dataAt: "NamedLists.$iinamedListItem.Values",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const NamedListItem = {
  displayName: "Item",
  dataAt: "NamedLists.$iinamedListItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [NamedListName,NamedListValues],
  endpoint: "Settings",
  removeParamId: "iinamedListItem",
  canDelete: true,
};

const NamedListsGrid = {
  tabName: "Named-Lists",
  displayName: "Named Lists",
  dataAt: "NamedLists",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: NamedListItem,
  gridCols: [
    { name: "Name", key: "Name" },
    { name: "Values", key: "Values" }
  ]
};

const NamedListsPanel = {
  tabName: "Named-Lists",
  dataAt:"",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ NamedListsGrid ],
};
//End Named List


//Country Airlines
const CountryAirlinesCountryCodes = {
  displayName: "CountryCodes",
  dataAt: "CountryAirlines.$iicountryAirlineListItem.CountryCodes",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryAirlinesCountryAirlines = {
  displayName: "Airlines",
  dataAt: "CountryAirlines.$iicountryAirlineListItem.Airlines",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
};

const CountryAirlinesCountryIsOriginDestinationInList = {
  displayName: "IsOriginDestinationInList",
  dataAt: "CountryAirlines.$iicountryAirlineListItem.IsOriginDestinationInList",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const CountryAirlinesItem = {
  displayName: "Item",
  dataAt: "CountryAirlines.$iicountryAirlineListItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [CountryAirlinesCountryCodes,CountryAirlinesCountryIsOriginDestinationInList,CountryAirlinesCountryAirlines],
  endpoint: "Settings",
  removeParamId: "iicountryAirlineListItem",
  canDelete: true,
};

const CountryAirlinesGrid = {
  tabName: "Country-Airlines",
  displayName: "Country Airlines",
  dataAt: "CountryAirlines",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: CountryAirlinesItem,
  gridCols: [
    { name: "CountryCodes", key: "CountryCodes" },
    { name: "Airlines", key: "Airlines" }
  ]
};

const CountryAirlinesPanel = {
  tabName: "Country-Airlines",
  dataAt:"",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ CountryAirlinesGrid ],
};
//End Country Airlines


//Start FlightModificationSettings
const FlightModificationSettingGdsProviders = {
  displayName: "Gds Providers",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.GdsProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
};

const FlightModificationSettingCarriersExcluded = {
  displayName: "Carriers Excluded",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.CarriersExcluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const FlightModificationSettingCarriersIncluded = {
  displayName: "Carriers Included",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.CarriersIncluded",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  validationRegex: "^$|^[A-Za-z0-9]{2}(?:[\\s,]+[A-Za-z0-9]{2})*$",
  validationMessage: "Use 2-character carrier codes (letters or numbers), e.g., AA, F9.",
};

const FlightModificationSettingEnableCancelRebook = {
  displayName: "Enable Cancel Rebook",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableCancelRebook",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const FlightModificationSettingEnableExchanges = {
  displayName: "Enable Exchanges",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableExchanges",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const FlightModificationSettingEnableAdd = {
  displayName: "Enable Add",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem.EnableAdd",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};
const FlightModificationSettingItem = {
  displayName: "Item",
  dataAt: "FlightModificationSettings.$iiflightModificationSettingItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightModificationSettingGdsProviders,FlightModificationSettingCarriersExcluded,
  FlightModificationSettingCarriersIncluded,
  FlightModificationSettingEnableCancelRebook,
  FlightModificationSettingEnableExchanges,
  FlightModificationSettingEnableAdd
],
  endpoint: "Settings",
  removeParamId: "iiflightModificationSettingItem",
  canDelete: true,
};
const FlightModificationSettingsGrid = {
  tabName: "Flight-Modification-Settings",
  displayName: "Flight Modification Settings",
  dataAt: "FlightModificationSettings",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: FlightModificationSettingItem,
  gridCols: [
    { name: "Providers", key: "GdsProviders" },
    { name: "CancelRebook", key: "EnableCancelRebook" },
    { name: "Exchanges", key: "EnableExchanges" },
    { name: "Add", key: "EnableAdd" },
    { name: "Excluded", key: "CarriersExcluded" },
    { name: "Included", key: "CarriersIncluded" },
  ]
};

//End FlightModificationSettings

// Start Custom Airport Hub
const SettingsCustomAirportHubName = {
  displayName: "Name",
  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem.Name",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const SettingsCustomAirportHubAirports = {
  displayName: "Airports",
  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem.Airports",
  displayAs: constants.DISPLAY_AS.TAG_INPUT
};

const SettingsCustomAirportHubsItem = {
  displayName: "Item",
  dataAt: "CustomAirportHubs.$isettingsCustomAirportHubsItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [SettingsCustomAirportHubName,
    SettingsCustomAirportHubAirports
],
  endpoint: "Settings",
  removeParamId: "isettingsCustomAirportHubsItem",
  canDelete: true,
};

const SettingsCustomAirportHubsGrid = {
  tabName: "Custom-Airport-Hubs",
  displayName: "Custom Airport Hubs",
  dataAt: "CustomAirportHubs",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: SettingsCustomAirportHubsItem,
  gridCols: [
   { name: "Name", key: "Name" },
    { name: "Airports", key: "Airports" }
  ]
};
// End Custom Airport Hub

//Start FlightSearch
const FlightSearchConfigurationCarrierType = {
  displayName: "Carrier Type",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsType",
  helpText: "Single: 1 search performed which includes all defined carriers. Multi: 1 search for each carrier defined."
};

const FlightSearchConfigurationCarriers = {
  displayName: "Carriers",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Carriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "<span class=\"help-block\">" +
      "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~<br/><br />" +
      "Enter XX with carrier type = Multi will perform an exclusion with all the other carriers excluded.<br/>" +
      "Example: XX, AA entered as values will perform 2 queries. 1 with AA and another with excluding AA and any other configured excluded carriers." +
      "</span>"
};

const FlightSearchConfigurationExcludeCarriers = {
  displayName: "Exclude Carriers",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.ExcludeCarriers",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "Named lists are supported. Wrap name in ~ characters. Example: ~ExcludedCarriers~"
};

const FlightSearchConfigurationCabinType = {
  displayName: "Cabin Type",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CabinType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightSearchConfigurationQueryItemsTypeMultiOnly",
  helpText: "Sabre only supports single cabin queries. Therefore Multi is the only available option."
};
const FlightSearchConfigurationCabins = {
  displayName: "Cabins",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Cabins",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightCabins"
};
const FlightSearchPassengerTypes = {
  displayName: "Passenger Types",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.PassengerTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PassengerTypes",
  allowFreeform: true,
  transformUppercase: true,
  validationRegex: "^[A-Z0-9]{3}$",
  validationMessage: "Each passenger type must be exactly 3 alphanumeric characters",
};
const FlightSearchConfigurationIncDebtorPreferred = {
  displayName: "Include Debtor Preferred",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IncDebtorPreferred",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationRefundableSearch = {
  displayName: "Penalty Search Type",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.RefundableSearchTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "PenaltySearchTypes",
};

const FlightSearchConfigurationUnbrandedSearch = {
  displayName: "Unbranded Search",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.UnbrandedSearch",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationEnableATPCO = {
  displayName: "Enable ATPCO",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.EnableATPCO",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationEnableNDC = {
  displayName: "Enable NDC",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.EnableNDC",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Leave Enabled ATPCO and Enabled NDC un-checked to use Debtor Configuration."
};
const FlightSearchConfigurationMaxStopsQuantity = {
  displayName: "Max Stops Quantity",
  dataAt:
    "FlightSearch.Queries.$iflightSearchConfigurationItem.MaxStopsQuantity",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationCountryOrigin = {
  displayName: "Origin Countries",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CountryOrigin",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Origin country codes are in the list. ** Named list support"
};
const FlightSearchConfigurationCountryDestination = {
  displayName: "Destination Countries",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CountryDestination",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  helpText: "If set, query will only be used if Destination country codes are in the list. ** Named list support"
};

const FlightSearchConfigurationPriority = {
  displayName: "Priority",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.Priority",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "FlightConfigurationPriority",
  html:"Leave blank for system configuration. Enter the order of priority. First 1 in list is the highest priority."
};

const FlightSearchConfigurationKeepSameCabin = {
  displayName: "Keep Same Cabin",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.KeepSameCabin",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationFareFocusRulesExclude = {
  displayName: "Fare Focus Rules Exclude",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.FareFocusRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationOfferControlRulesExclude = {
  displayName: "Offer Control Rules Exclude",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.OfferControlRulesExclude",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationItineraryCount = {
  displayName: "Itinerary Count",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.ItineraryCount",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationNumTrips = {
  displayName: "Num Trips",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.NumTrips",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne = {
  displayName: "Vendor Pref Applicability AtLeast One",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.VendorPrefApplicabilityAtLeastOne",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationCarrierFilterApplyValidatingCarrier = {
  displayName: "Carrier Filter Apply Validating Carrier",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.CarrierFilterApplyValidatingCarrier",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationDiversityHandling = {
  displayName: "Diversity Handling",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.DiversityHandling",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "DiversityHandlingType"
};

const FlightSearchConfigurationAdditionalNonStopsPercentage = {
  displayName: "Additional NonStops Percentage",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.AdditionalNonStopsPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketFareCutOffPercentage = {
  displayName: "Low Fare Bucket Fare Cut Off Percentage",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketFareCutOffPercentage",
  helpText: "BFM Configuration leave blank for default configuration",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationLowFareBucketOptionsPercentage = {
  displayName: "Low FareBucket Options Percentage",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.LowFareBucketOptionsPercentage",
  helpText: "BFM Configuration leave blank for default configuration.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
const FlightSearchConfigurationSetBrandedFareOptions = {
  displayName: "Set BrandedF are Options",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.SetBrandedFareOptions",
  helpText: "When not checked system will use system configuration. To override check this box and set Multiple and Single branded fare values below.",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const FlightSearchConfigurationMultipleBrandedFare = {
  displayName: "Multiple Branded Fare",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.MultipleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationSingleBrandedFare = {
  displayName: "Single Branded Fare",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.SingleBrandedFare",
  helpText: "BFM Configuration leave blank for default configuration. Ignored when Set Branded Fare Options = false",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};

const FlightSearchConfigurationTimeWindowsOutbound = {
  displayName: "Time Windows Outbound",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowsOutbound",
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  html: "List of time windows. <br/>- use for empty value. This means system will use configured time window. Either none or configured default time window. <br/>" + 
  "Format: HHmmHHmm example: 12002359 Begin time in HHmm followed by end time HHmm. Note end time 2400 is not valid. Enter 2359.<br/> " + 
  "Example all day: 00002359<br/>" + 
  "Enter number for plus or minus range. Example 120 will be plus and minus 120 min from chosen depart time.",
};

const FlightSearchConfigurationTimeWindowRange = {
  displayName: "Time Window Range (Min)",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.TimeWindowRange",
  helpText: "Overrides configuration with defined plus and minus time wondow for searched for time.",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};

const FlightSearchConfigurationIsCombinable = {
  displayName: "Is Combinable",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IsCombinable",
  helpText: "Search configuration is only included if doing a combinable search or not. Leave blank or not set to always include.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true
};
const FlightSearchConfigurationIncludeCountryCarriers = {
  displayName: "Include Country Carriers",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem.IncludeCountryCarriers",
  helpText: "System to include Country Carriers in carrier list. Based on origin and destination countries.",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "BoolNullableType",
  handleAsString:true,
  allowNullable:true,
};

const FlightSearchConfigurationItem = {
  displayName: "Item",
  dataAt: "FlightSearch.Queries.$iflightSearchConfigurationItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [FlightSearchConfigurationCarrierType,
    FlightSearchConfigurationCarriers,
    FlightSearchConfigurationExcludeCarriers,
    FlightSearchConfigurationCabinType,
    FlightSearchConfigurationCabins,
    FlightSearchConfigurationRefundableSearch,
    FlightSearchPassengerTypes,
    FlightSearchConfigurationIncDebtorPreferred,
    FlightSearchConfigurationUnbrandedSearch,
    FlightSearchConfigurationEnableATPCO,
    FlightSearchConfigurationEnableNDC,
    FlightSearchConfigurationMaxStopsQuantity,
    FlightSearchConfigurationCountryOrigin,
    FlightSearchConfigurationCountryDestination,

    FlightSearchConfigurationIsCombinable,
    FlightSearchConfigurationIncludeCountryCarriers,
    FlightSearchConfigurationTimeWindowsOutbound,
    FlightSearchConfigurationTimeWindowRange,
    FlightSearchConfigurationPriority,
    FlightSearchConfigurationKeepSameCabin,
    FlightSearchConfigurationFareFocusRulesExclude,
    FlightSearchConfigurationOfferControlRulesExclude,
    FlightSearchConfigurationItineraryCount,
    FlightSearchConfigurationNumTrips,
    FlightSearchConfigurationVendorPrefApplicabilityAtLeastOne,
    FlightSearchConfigurationCarrierFilterApplyValidatingCarrier,
    FlightSearchConfigurationDiversityHandling,
    FlightSearchConfigurationAdditionalNonStopsPercentage,
    FlightSearchConfigurationLowFareBucketFareCutOffPercentage,
    FlightSearchConfigurationLowFareBucketOptionsPercentage,
    FlightSearchConfigurationSetBrandedFareOptions,
    FlightSearchConfigurationMultipleBrandedFare,
    FlightSearchConfigurationSingleBrandedFare,
],
  endpoint: "Settings",
  removeParamId: "iflightSearchConfigurationItem",
  canDelete: true,
};
const FlightSearchGrid = {
  tabName: "Flight-Search-Configuration",
  displayName: "Flight Search Configuration",
  dataAt: "FlightSearch.Queries",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: FlightSearchConfigurationItem,
  gridCols: [
   { name: "CrrT", key: "CarrierType" },
    { name: "Crrs", key: "Carriers" },
    { name: "ExCrrs", key: "ExcludeCarriers" },
    { name: "CbnT", key: "CabinType" },
    { name: "Cbn", key: "Cabins" },
    { name: "Rfd", key: "RefundableSearchTypes" },
    { name: "Pax", key: "PassengerTypes" },
    { name: "Pref", key: "IncDebtorPreferred" },
    { name: "UnBrd", key: "UnbrandedSearch" },
    { name: "ATPCO", key: "EnableATPCO" },
    { name: "NDC", key: "EnableNDC" },
    { name: "Stp", key: "MaxStopsQuantity" },
    { name: "Org", key: "CountryOrigin" },
    { name: "Dst", key: "CountryDestination" },
  ]
};
//End FlightSearch

//Start FlightAncillaryCodesConfiguration
const FlightAncillaryCodesAncillaryType = {
  displayName: "Ancillary Type",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.AncillaryType",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  helpText: "Type of Ancillary, as shown in Sabre or the GDS"
};

const FlightAncillaryCodesAncillaryName = {
  displayName: "Ancillary Name",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.DisplayName",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 50,
  helpText: "Display name, as it will be shown here in config."
};

const FlightAncillaryCodesAncillaryRequireFreeFormText = {
  displayName: "Require Free Form Text",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.RequireFreeFormText",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "If the SSR message for this ancillary requires free form text, indicate true or false."
};

const FlightAncillaryCodesAncillaryFreeFormText = {
  displayName: "Free Form Text",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.FreeFormText",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 100,
  helpText: "Free form text for this ancillary, if applicable."
};

const FlightAncillaryCodesAncillaryCode = {
  displayName: "Ancillary Code",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 10,
  helpText: "Ancillary code"
};

const FlightAncillaryCodesAncillaryFreeOfCost = {
  displayName: "Free Of Cost",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.FreeOfCost",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Indicates if the ancillary is free of cost"
};

const FlightAncillaryCodesAncillaryIsEnabled = {
  displayName: "Enabled",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.IsEnabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
  helpText: "Indicates if the ancillary is enabled"
};

const FlightAncillaryCodesAncillaryProviders = {
  displayName: "Providers",
  dataAt: "FlightAncillaryCodes.$iflightAncillaryCodesItem.Providers",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  optionsAt: "GDSProviders",
  helpText: "GDS Providers associated with this ancillary"
};

const FlightAncillaryCodesItem = {
  displayName: "Item",
  dataAt: "FlightAncillaryCodes",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    FlightAncillaryCodesAncillaryType,
    FlightAncillaryCodesAncillaryName,
    FlightAncillaryCodesAncillaryRequireFreeFormText,
    FlightAncillaryCodesAncillaryFreeFormText,
    FlightAncillaryCodesAncillaryCode,
    FlightAncillaryCodesAncillaryFreeOfCost,
    FlightAncillaryCodesAncillaryIsEnabled,
    FlightAncillaryCodesAncillaryProviders
  ],
  endpoint: "Settings",
  removeParamId: "iflightAncillaryCodesItem",
  canDelete: true,
};

const FlightAncillaryCodesGrid = {
  tabName: "Flight-Ancillary-Codes",
  displayName: "Flight Ancillary Codes",
  dataAt: "FlightAncillaryCodes",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  copyWithoutCopyText: true,
  gridItem: FlightAncillaryCodesItem,
  gridCols: [
    { name: "Ancillary Type", key: "AncillaryType" },
    { name: "Display Name", key: "DisplayName" },
    { name: "Require Free Form Text", key: "RequireFreeFormText" },
    { name: "Free Form Text", key: "FreeFormText" },
    { name: "Code", key: "Code" },
    { name: "Free Of Cost", key: "FreeOfCost" },
    { name: "Enabled", key: "IsEnabled" },
    { name: "Providers", key: "Providers" },
  ]
};
//End FlightAncillaryCodesConfiguration

//Start FlightNdcAtpcoTieSettings
const FlightNdcAtpcoTieSettingsApplicationType = {
  displayName: "NDC ATPCO Tie Settings Application Type",
  dataAt: "FlightNdcAtpcoTieSettings.ApplicationType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsApplicationType",
  html:constants.MESSAGES.NDC_TIE_SETTINGS
};

const FlightNdcAtpcoTieSettingsThresholdType = {
  displayName: "NDC ATPCO Tie Settings Threshold Type",
  dataAt: "FlightNdcAtpcoTieSettings.ThresholdType",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "FlightNdcAtpcoTieSettingsThresholdType",
};

const FlightNdcAtpcoTieSettingsThresholdValue = {
  displayName: "NDC ATPCO Tie Settings Threshold Value",
  dataAt: "FlightNdcAtpcoTieSettings.ThresholdValue",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "number",
};
//End FlightNdcAtpcoTieSettings

const FlightPanel = {
  tabName: "Flight",
  dataAt:"",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [ 
    FlightModificationSettingsGrid, 
    FlightSearchGrid,
    FlightAncillaryCodesGrid,
    FlightNdcAtpcoTieSettingsApplicationType, 
    FlightNdcAtpcoTieSettingsThresholdType, 
    FlightNdcAtpcoTieSettingsThresholdValue,
    SettingsCustomAirportHubsGrid
],
};

const SettingsTabs = {
  displayName: "Settings",
  iconClass: "fa-cog",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    SettingsMiscPanel,
    ApprovalPanel,
    AdditionalPnrRemarksPanel,
    GuestTravellersTitlesPanel,
    PnrFinishingRemarksPanel,
    SettingsGDSPanel,
    CountryPnrFinishingRemarksGrid,
    SalesAgentsPanel,
    HotelPanel,
    RailPanel,
    FlightPanel,
    PerDiemPanel,
    ConfigReportPanel,
    UnusedTicketPanel,
    DatetimeFormatPanel,
    NamedListsPanel,
    CreditCardMappingsPanel,
    CountryAirlinesPanel
  ],
};

const SettingsResource = {
  rootNode: true,
  displayName: "Settings",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  iconClass: "fa-cog",
  dataAt: "",
  children: [SettingsTabs],
  endpoint: "Settings",
};

export default {
  SettingsResource,
  SettingsTabs,
  SettingsMiscPanel,
  AdditionalPnrRemarksPanel,
  GuestTravellersTitlesPanel,
  PnrFinishingRemarksPanel,
  SettingsGDSPanel,
  UnusedTicketPanel,
  DatetimeFormatPanel,
  CountryPnrFinishingRemarksGrid,
  ApprovalPanel,
  SalesAgentsPanel,
  HotelPanel,
  RailPanel,
  FlightPanel,
  PerDiemPanel,
  NamedListsPanel,
  CreditCardMappingsPanel,
  CountryAirlinesPanel,
  Id,
  FlightFareClasses,
  FlightFareBucketClassesGrid,
  SalesAgentRemark,
  SalesAgentsGrid,
  PerDiemDefaultRatesGrid,
  PerDiemMappingsGrid,
  RailCharacterMappingsGrid,
  LimitCountries,
  SettingsRadiusDistance,
  MinimumHotelRating,
  HotelRateCategoriesGrid,
  HotelAmenityFiltersGrid,
  ErrorMessagesGrid,
  DefaultFareRules,
  FlightFareDataGrid,
  TermsAndConditionsGrid,
  VehicleDefaultsGrid,
  VehicleEmissionsGrid,
  CreditCardMappingsGrid,
  AdditionalPnrRemarksApprovalRemarks,
  AdditionalPnrRemarksDeclinedRemarks,
  AdditionalPnrRemarksDeclinedRemarksNonRefundable,
  AdditionalPnrRemarksExpiredRemarks,
  AdditionalPnrRemarksCancelRemarks,
  AdditionalPnrRemarksModifyRemarks,
  AdditionalPnrRemarksUserHoldRemarks,
  AdditionalPnrRemarksExpiredUserHoldRemarks,
  AdditionalPnrRemarksConfirmedUserHoldRemarks,
  AdditionalPnrRemarksFinishBookingRemarks,
  GuestTravellersTitlesGridItem,
  PnrFinishingRemarksPanelGuestTravellerExclusions,
  PnrFinishingRemarksPanelGuestTravellerRemarks,
  PnrFinishingRemarksPanelPreTripApprovalExclusions,
  PnrFinishingRemarksPanelPreTripApprovalRemarks,
  PnrFinishingRemarksPanelStandardRemarks,
  Gdssettings,
  CountryPnrFinishingRemarksGridItem,
  FlightFareBucketClassesItem,
  SalesAgentsItem,
  PerDiemDefaultRatesItem,
  PerDiemMappingsItem,
  HotelRateCategoriesItem,
  HotelAmenityFiltersItem,
  RailCharacterMappingsItem,
  ErrorMessagesItem,
  FlightFareDataItem,
  TermsAndConditionsSettingsItem,
  VehicleDefaultsItem,
  VehicleEmissionsItem,
  CreditCardMappingsItem,
  GuestTravellersTitlesGroup,
  GdssettingsItem,
  CountryPnrFinishingRemarksCountryCode,
  CountryPnrFinishingRemarksPnrFinishingRemarksExclusionRemarks,
  CountryPnrFinishingRemarksPnrFinishingRemarksStandardRemarks,
  CountryPnrFinishingRemarksHostCommands,
  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksExclusions,
  CountryPnrFinishingRemarksPnrFinishingRemarksPreTripApprovalRemarksRemarks,
  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksExclusions,
  CountryPnrFinishingRemarksPnrFinishingRemarksGuestTravellerRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksApprovalRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksDeclinedRemarksNonRefundableRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksCancelRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksModifyRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksRemarks,
  CountryPnrFinishingRemarksAdditionalPnrRemarksUserHoldRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksExclusions,
  CountryPnrFinishingRemarksAdditionalPnrRemarksExpiredUserHoldRemarksRemarks,
  CountryPnrFinishingRemarksGdsRemarksGrid,
  FlightFareBucketClassesName,
  FlightFareBucketClassesSort,
  FlightFareBucketClassesFareClasses,
  SalesAgentsIsEnabled,
  SalesAgentsName,
  SalesAgentsCode,
  PerDiemDefaultRatesEffectiveDate,
  PerDiemDefaultRatesCountry,
  PerDiemDefaultRatesAmount,
  PerDiemMappingsValue,
  PerDiemMappingsAlternateValues,
  PerDiemMappingsType,
  HotelRateCategoriesName, 
  HotelRateCategoriesKeywords, 
  HotelRateCategoriesContractCodes, 
  HotelRateCategoriesSabreSourceType,
  HotelRateCategoriesFilterDisplayName,
  HotelRateCategoriesLogoUrl, 
  HotelRateCategoriesDisplayOnTop,
  HotelRateCategoriesIsAggregator,
  HotelAmenityFiltersDisplayName, 
  HotelAmenityFiltersAmenities, 
  HotelAmenityFiltersMostPopular,
  RailCharacterMappingsSpecialCharacter,
  RailCharacterMappingsSystemCharacter,
  ErrorMessagesKey,
  ErrorMessagesValue,
  ErrorMessagesUseRegularExpressions,
  FlightFareDataName,
  FlightFareDataFareClassType,
  FlightFareDataMixedTypeRestriction,
  FlightFareDataRefundableRestriction,
  FlightFareDataRefundPenaltyRestriction,
  FlightFareDataChangeableRestriction,
  FlightFareDataBasicRestriction,
  TermsAndConditionsSectionType,
  TermsAndConditionsCountries,
  TermsAndConditionsSegmentTypes,
  TermsAndConditionsText,
  VehicleDefaultsName,
  VehicleDefaultsCategoryCode,
  VehicleDefaultsTypeCode,
  VehicleDefaultsImageUrl,
  GuestTravellersTitlesCode,
  GuestTravellersTitlesName,
  GuestTravellersTitlesDisplayOrder,
  GuestTravellersTitlesIsDeleted,
  GuestTravellersTitlesValid,
  GuestTravellersTitlesEnabled,
  GdsName,
  GdsEnabled,
  GdsSettings,
  CountryPnrFinishingRemarksGdsRemarksItem,
  CountryPnrFinishingRemarksGdsRemarksName,
  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksRemarks,
  CountryPnrFinishingRemarksGdsRemarksFinishingRemarksExclusions,
  CountryPnrFinishingRemarksGdsRemarksSeatRemarks,
  CountryPnrFinishingRemarksGdsRemarksAncillaryRemarks,
  GdsPassiveFlightSegmentRemarkTemplate,
  ConfigReportPanel,
  ConfigReportDownloader,
  ConfigFileUploader,
  RegionalMobileContactDetailsFileUploader,
  HotelPreferredTagsSourceType,
  HotelTagsToIgnoreFromDatabase,
  HotelDepositRequiredAndPrepayKeywords,
  HotelNonRefundableKeywords,
  HotelOtherExcludedKeywords,
  ItineraryValidatorSettings,
  BookingThreshold,
  NamedListItem,
  FlightModificationSettingItem,
  SettingsCustomAirportHubsItem,
  SettingsCustomAirportHubName,
  SettingsCustomAirportHubAirports,
  FlightSearchConfigurationItem,
  CreditCardMappingsCardProvider,
  CreditCardMappingsCardTypes,
  EnableNewUiSystemSetting,
  CountryAirlinesItem,
  FlightAncillaryCodesItem,
  TaxDisplayModeSystemSetting
};



// WEBPACK FOOTER //
// ./src/config/fields/settingsResource.js